import { useState, useEffect } from "react"
import { utc, localTime } from "../pages/pageUtils"

const useInputAlert = (
  activeSearch: boolean,
  dispatch: any,
  useLocalTime: boolean
) => {
  const [selectedTime, setSelectedTime] = useState("local")
  const [showModal, setShowModal] = useState(false)
  const [local, setLocal] = useState(true)

  useEffect(() => {
    if (useLocalTime) {
      setSelectedTime(localTime)
    } else {
      setSelectedTime(utc)
    }
  }, [useLocalTime])

  useEffect(() => {
    if (useLocalTime) {
      setSelectedTime(localTime)
    } else {
      setSelectedTime(utc)
    }
    if (selectedTime === utc) {
      setLocal(true)
    } else {
      setLocal(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTime])

  const dispatchFn = () => {
    if (selectedTime === utc) {
      setSelectedTime("local")
    } else {
      setSelectedTime(utc)
    }
    dispatch()
  }

  const handleTimeChange = () => {
    if (activeSearch) {
      setShowModal(true)
    } else {
      dispatchFn()
    }
  }
  const handleCloseModal = () => {
    setShowModal(false)
  }
  const handleResetFlights = () => {
    setShowModal(false)
    dispatchFn()
  }

  return {
    handleTimeChange,
    handleCloseModal,
    handleResetFlights,
    local,
    showModal,
    selectedTime
  }
}

export default useInputAlert
